import { render, staticRenderFns } from "./boolean-radio-field.vue?vue&type=template&id=6b40eb4a&scoped=true&"
import script from "./boolean-radio-field.vue?vue&type=script&lang=js&"
export * from "./boolean-radio-field.vue?vue&type=script&lang=js&"
import style0 from "./boolean-radio-field.vue?vue&type=style&index=0&id=6b40eb4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b40eb4a",
  null
  
)

export default component.exports